import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Cpu, Users2, Rocket, Headphones, FileSearch } from "lucide-react";
import "./Vantagens.css";

function Vantagens() {
  const vantagens = [
    {
      icon: <Cpu size={42} />,
      titulo: "Tecnologia própria e segura",
      texto:
        "Desenvolvemos nossas soluções internamente, com infraestrutura em nuvem, controle de acesso e total conformidade com a LGPD.",
    },
    {
      icon: <Users2 size={42} />,
      titulo: "Experiência comprovada",
      texto:
        "Mais de 10 anos atendendo órgãos públicos, bancos e grandes empresas com milhões de imagens digitalizadas e indexadas.",
    },
    {
      icon: <Rocket size={42} />,
      titulo: "Operações em escala",
      texto:
        "Capacidade técnica e logística para atender grandes volumes com eficiência, qualidade e rastreabilidade completa.",
    },
    {
      icon: <Headphones size={42} />,
      titulo: "Suporte humano e ágil",
      texto:
        "Atendimento personalizado, equipe dedicada e comunicação direta durante todas as etapas do contrato.",
    },
    {
      icon: <ShieldCheck size={42} />,
      titulo: "Solidez e credibilidade",
      texto:
        "A confiança de clientes como Vale, Unimed, COHAB-MG reforça nossa reputação e excelência.",
    },
    {
      icon: <FileSearch size={42} />,
      titulo: "Rastreabilidade e auditoria completa",
      texto: "Cada documento é controlado em todas as etapas, com trilhas de auditoria, logs de acesso e total transparência nos processos.",
    },

  ];

  return (
    <section className="Vantagens">
      <div className="vantagens-bg"></div>
      <motion.div
        className="vantagens-container"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="titulo-vantagens">Por que escolher a <span>CEDOC</span></h2>
        <p className="subtitulo-vantagens">
          Transformamos a gestão documental em eficiência, segurança e resultados reais.
        </p>

        <div className="cards-vantagens">
          {vantagens.map((v, index) => (
            <motion.div
              key={index}
              className="card-vantagem"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="icon">{v.icon}</div>
              <h3>{v.titulo}</h3>
              <p>{v.texto}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}

export default Vantagens;
